export enum VisibleMessageType {
    None = 0,
    Current = 1,
    History = 2,
    All = 3,
}
